import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

let Root = App;
// Development-only QA harness for the Pages view; the condition is constant-folded away in production builds.
if (process.env.NODE_ENV === 'development' && window.location.pathname === '/__dev/pages') {
  const PagesHarness = React.lazy(() => import('./dev/PagesHarness'));
  Root = () => (
    <React.Suspense fallback={null}>
      <PagesHarness />
    </React.Suspense>
  );
}
// Development-only QA harness for the deck template editor (same pattern as /__dev/pages).
if (process.env.NODE_ENV === 'development' && window.location.pathname === '/__dev/deck') {
  const DeckHarness = React.lazy(() => import('./dev/DeckHarness'));
  Root = () => (
    <React.Suspense fallback={null}>
      <DeckHarness />
    </React.Suspense>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
